import _ from 'lodash';
import React, {FunctionComponent, useState, useEffect} from 'react';
import {Grid, makeStyles} from '@material-ui/core';
import {ProductData, ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {searchProducts} from '~/lib/product';
import {TreezColor, treezColorMap} from '~/styles/constants';
import {SearchFilter} from '~/utils/ProductAPI';
import ProductColumnCarousel from '../ProductColumnCarousel';

const {TREEZ_GREEN} = TreezColor;

interface Props {
    brandProductToMergeTo?: ProductInCatalog;
    setBrandProductToMergeTo: (brandProduct: ProductInCatalog) => void;
    searchParams: Record<ProductData, string[]>;
    fieldsToShow: ProductData[];
}

export const BrandTreezColumn: FunctionComponent<Props> = (props: Props) => {
    const {brandProductToMergeTo, setBrandProductToMergeTo, searchParams, fieldsToShow} = props;

    const [isSearching, setIsSearching] = useState<boolean>(false);
    const [suggestedBrandProducts, setSuggestedBrandProducts] = useState<ProductInCatalog[]>();

    const searchForBrandProducts = async () => {
        setIsSearching(true);
        const searchTerm = _.get(searchParams, 'name') as string;
        const searchFields = _.omit(searchParams, ['name']);

        const filters = _.map(_.keys(searchFields), (param) => {
            return {
                field: param,
                values: searchParams[param],
                fuzzy: true,
            } as SearchFilter;
        });
        const brandResults = await searchProducts({
            searchTerm,
            filters,
        });

        const {data} = brandResults;
        setSuggestedBrandProducts(data);
        setIsSearching(false);
    };

    const removeBrandProduct = (productId: number) => {
        // TODO - REMOVE BRAND COLUMN
        console.log(productId);
    };

    useEffect(() => {
        searchForBrandProducts;
    }, []);

    const useStyles = makeStyles({
        placeholder: {
            display: 'flex',
        },
        suggestedResultsColumn: {
            display: 'flex',
        },
        brandProductToMergeToColumn: {
            display: 'flex',
        },
        customOverviewCell: {
            backgroundColor: treezColorMap[TREEZ_GREEN],
        },
    });

    const {placeholder, suggestedResultsColumn, brandProductToMergeToColumn} = useStyles();

    return (
        <Grid>
            {isSearching && <Grid item className={placeholder} sm={12} />}
            {!isSearching && brandProductToMergeTo == null && (
                <Grid item className={suggestedResultsColumn} sm={12}>
                    <ProductColumnCarousel
                        products={suggestedBrandProducts}
                        fieldsToShow={fieldsToShow}
                        mergeToThisProduct={setBrandProductToMergeTo}
                        removeProduct={removeBrandProduct}
                    />
                </Grid>
            )}
            {brandProductToMergeTo && isSearching === false && (
                <Grid item className={brandProductToMergeToColumn} sm={12} />
            )}
        </Grid>
    );
};

export default BrandTreezColumn;
